"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.49172 11.6365C5.44539 16.9514 8.70455 19.3673 14.1409 24.199C19.7248 19.3076 22.984 16.8619 27.0451 11.4813C28.673 8.73748 27.163 4.74656 25.0145 2.67681C23.3588 1.08145 21.448 0.964921 19.4175 1.45406C16.7335 2.17623 15.8645 2.92149 14.3412 4.38891C12.8582 2.9394 12.0121 2.20322 9.39906 1.48986C7.42226 1.00669 5.08049 1.3635 3.46857 2.93939C1.37694 4.98389 -0.305622 9.22065 1.49172 11.6365Z",
  fill: "currentColor",
  strokeWidth: "5%"
})), 'Heart', {
  width: 29,
  height: 25,
  viewBox: '0 0 29 25'
});

exports.default = _default;